import React, { useEffect, useRef } from "react";
import { ActivityIndicator, StyleSheet, Text, View } from "react-native";
import { useNavigation } from "@react-navigation/native";
import { useUser } from "../Widgets/UserContext";
import { recordKeychainVisit } from "../services/KeychainCampaignService";

const KeychainRedirect = () => {
  const navigation = useNavigation();
  const { currentUser, currentUserData, authLoading } = useUser();
  const hasRedirectedRef = useRef(false);

  useEffect(() => {
    if (authLoading || hasRedirectedRef.current) return;

    hasRedirectedRef.current = true;

    const redirect = async () => {
      const isLoggedIn = Boolean(currentUser && !currentUser.isAnonymous);
      await recordKeychainVisit({
        authUser: isLoggedIn ? currentUser : null,
        userData: isLoggedIn ? currentUserData : null,
      });

      navigation.replace(isLoggedIn ? "Hub" : "My Tassel - Welcome");
    };

    redirect();
  }, [authLoading, currentUser, currentUserData, navigation]);

  return (
    <View style={styles.container}>
      <ActivityIndicator size="large" color="#4c956c" />
      <Text style={styles.text}>Redirecting...</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#ffffff",
  },
  text: {
    marginTop: 12,
    color: "#475569",
    fontSize: 16,
  },
});

export default KeychainRedirect;
